import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { features, scrollToSection } from "@/data/landingData";

const HeroSection = () => (
  <section id="funcionalidades" className="relative min-h-dscreen flex items-center justify-center pt-24 pb-20 sm:pt-20 hero-gradient overflow-hidden">
    <div className="absolute inset-0 overflow-hidden">
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-primary/5 rounded-full blur-3xl animate-float" style={{ animationDelay: "1s" }} />
    </div>


    <div className="container mx-auto px-5 sm:px-4 relative z-10 mt-6">
      <div className="max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-3 py-2 sm:px-4 bg-primary/10 border border-primary/20 rounded-full mb-6 animate-fade-in">
          <Sparkles className="w-4 h-4 shrink-0 text-primary" />
          <span className="text-xs sm:text-sm text-primary">Baseado na Teoria das 12 Personas de Estilo</span>
        </div>

        <h1 className="font-display text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight animate-slide-up">
          O que oferecemos em nosso
          <span className="block text-gradient-green">Portal das 12 Personas de Estilo</span>
        </h1>

        <p className="text-base sm:text-xl md:text-2xl text-muted-foreground mb-10 sm:mb-12 max-w-3xl mx-auto animate-slide-up" style={{ animationDelay: "0.1s" }}>
          Ferramentas únicas para você evoluir e expressar seu estilo.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-6xl mx-auto mb-10 sm:mb-12 animate-slide-up" style={{ animationDelay: "0.2s" }}>
          {features.map((feature, index) => (
            <div
              key={feature.title}
              onClick={() => scrollToSection(feature.sectionId)}
              className="card-hover text-center cursor-pointer group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-4 rounded-2xl bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-colors">
                <feature.icon className="w-6 h-6 sm:w-8 sm:h-8 text-primary" />
              </div>
              <h4 className="font-display text-lg sm:text-xl font-semibold mb-2 group-hover:text-primary transition-colors">{feature.title}</h4>
              <p className="text-muted-foreground text-xs sm:text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="animate-slide-up" style={{ animationDelay: "0.3s" }}>
          <Link to="/teste" className="btn-elegant inline-flex w-full sm:w-auto items-center justify-center gap-2 text-sm sm:text-lg px-6 sm:px-10 py-3.5 sm:py-4 animate-pulse-glow">
            Começar com o Teste Express Gratuito
            <ArrowRight className="w-5 h-5 shrink-0" />
          </Link>
        </div>

        <div className="hidden sm:block absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-muted-foreground/30 rounded-full flex justify-center pt-2">
            <div className="w-1.5 h-3 bg-primary rounded-full" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
